import React from 'react';
import { motion } from 'framer-motion';
import { Clock, ChefHat, Zap } from 'lucide-react';
export function SystemSection() {
  return <section className="py-20 px-4 overflow-hidden relative bg-[#F2F1EE]" data-id="element-165">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-olive/5 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" data-id="element-166"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-terracotta/5 rounded-full blur-3xl translate-x-1/3 translate-y-1/3" data-id="element-167"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-168">
        <div className="text-center mb-16" data-id="element-169">
          <span className="font-bold tracking-wider text-sm uppercase mb-2 block text-[#DF1189]" data-id="element-170">
            La Solución
          </span>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-charcoal mb-6" data-id="element-171">
            Presentando el Sistema 2×25
          </h2>
          <p className="text-xl text-charcoal-light max-w-2xl mx-auto" data-id="element-172">
            Dos mini-preps de 25 minutos por semana. <br data-id="element-173" />
            La freidora de aire hace el trabajo pesado.
          </p>
        </div>

        {/* The 2x25 Visual */}
        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-174">
          <motion.div whileHover={{
          y: -5
        }} className="bg-white p-8 rounded-2xl shadow-md border-t-4 border-olive flex flex-col items-center text-center" data-id="element-175">
            <div className="w-16 h-16 bg-olive/10 rounded-full flex items-center justify-center mb-6 text-olive" data-id="element-176">
              <Clock className="w-8 h-8" data-id="element-177" />
            </div>
            <h3 className="text-2xl font-serif font-bold text-charcoal mb-2" data-id="element-178">
              Domingo (25 min)
            </h3>
            <p className="text-charcoal-light" data-id="element-179">
              Preparas 1–2 bases "ganadoras" para arrancar la semana con fuerza.
            </p>
          </motion.div>

          <motion.div whileHover={{
          y: -5
        }} className="bg-white p-8 rounded-2xl shadow-md border-t-4 border-terracotta flex flex-col items-center text-center" data-id="element-180">
            <div className="w-16 h-16 bg-terracotta/10 rounded-full flex items-center justify-center mb-6 text-terracotta" data-id="element-181">
              <Zap className="w-8 h-8" data-id="element-182" />
            </div>
            <h3 className="text-2xl font-serif font-bold text-charcoal mb-2" data-id="element-183">
              Miércoles (25 min)
            </h3>
            <p className="text-charcoal-light" data-id="element-184">
              Haces un "reset" rápido para no caerte y salvar el resto de la
              semana.
            </p>
          </motion.div>
        </div>

        {/* The Formula */}
        <div className="text-cream p-8 md:p-12 rounded-3xl shadow-xl text-center bg-[#4a4a4a]" data-id="element-185">
          <h3 className="text-2xl md:text-3xl font-serif font-bold mb-8" data-id="element-186">
            La fórmula que te quita decisiones
          </h3>

          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 mb-8" data-id="element-187">
            <div className="flex flex-col items-center" data-id="element-188">
              <span className="text-4xl mb-2" data-id="element-189">🍗</span>
              <span className="font-bold text-lg" data-id="element-190">Proteína</span>
            </div>
            <span className="text-2xl text-terracotta font-bold" data-id="element-191">+</span>
            <div className="flex flex-col items-center" data-id="element-192">
              <span className="text-4xl mb-2" data-id="element-193">🍚</span>
              <span className="font-bold text-lg" data-id="element-194">Base</span>
            </div>
            <span className="text-2xl text-terracotta font-bold" data-id="element-195">+</span>
            <div className="flex flex-col items-center" data-id="element-196">
              <span className="text-4xl mb-2" data-id="element-197">🥜</span>
              <span className="font-bold text-lg" data-id="element-198">Crunch</span>
            </div>
            <span className="text-2xl text-terracotta font-bold" data-id="element-199">+</span>
            <div className="flex flex-col items-center" data-id="element-200">
              <span className="text-4xl mb-2" data-id="element-201">🥣</span>
              <span className="font-bold text-lg" data-id="element-202">Salsa</span>
            </div>
          </div>

          <p className="text-lg md:text-xl text-cream/80 max-w-2xl mx-auto" data-id="element-203">
            Eso es todo. Porque el secreto no es "comer perfecto". <br data-id="element-204" />
            El secreto es que, cuando estás cansada,{' '}
            <span className="font-bold text-[#DF1189]" data-id="element-205">
              no dependas de pensar.
            </span>
          </p>
        </div>

        <div className="mt-12 text-center" data-id="element-206">
          <p className="text-xl text-charcoal font-medium" data-id="element-207">
            Dejas de cocinar diario para empezar a{' '}
            <span className="italic font-serif text-2xl text-[#DF1189]" data-id="element-208">
              ensamblar
            </span>
            .
          </p>
        </div>
      </div>
    </section>;
}